import { render, staticRenderFns } from "./MedalDetails.vue?vue&type=template&id=e6e45058&"
import script from "./MedalDetails.vue?vue&type=script&lang=js&"
export * from "./MedalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports